import axios from "axios";

export default function ProfileShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/my-profile",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
